import { render } from "./ClampText.vue?vue&type=template&id=67a5ec6c&scoped=true"
import script from "./ClampText.vue?vue&type=script&lang=js"
export * from "./ClampText.vue?vue&type=script&lang=js"

import "./ClampText.vue?vue&type=style&index=0&id=67a5ec6c&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5ec6c"]])

export default __exports__